import { Server } from './server';
import { ServerConfig } from './serverConfig';
import { Service, ServiceResponse } from './service';
import { DeleteObjectCommand, GetObjectAttributesCommand, GetObjectCommand, GetObjectTaggingCommand, HeadObjectCommand, ListObjectsCommand, ListObjectsV2Command, PutObjectCommand, S3, S3Client } from "@aws-sdk/client-s3";
import Compressor from 'compressorjs';

// https://docs.aws.amazon.com/AWSJavaScriptSDK/v3/latest/client/s3/

// https://kgotgit.medium.com/how-to-save-files-to-aws-s3-bucket-using-temporary-credentials-via-aws-cognito-aws-sdk-javascript-3dfa14ac20a6

export class MediaService extends Service {
  protected S3:any;

  constructor() {
    super();

    this.S3 = new S3({
      region: 'us-west-2',
      credentials: {
        accessKeyId: 'AKIARUL7HL5CHC2M5Y6A',
        secretAccessKey: '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'
      }
    });
  }

  public async init(): Promise<ServiceResponse> {
    return {success: true};
  }

  public async sync(): Promise<ServiceResponse> {
    return {success: true};
  }

  // helpers
  protected async sendMediaCommand(command:string, params:any, data?:string) {
    let response = await this.sendCommand('media', command, params);
    if(response.status != 200)
      return {success: false, message: response.body.message};
    let ret:any = {success: true};
    if(data)
      ret[data] = response.body[data];
    return ret;
  }
  
  protected generateThumbImage(file: any, metadata: any) {
    let newWidth = metadata.width >= metadata.height ? 250 : undefined;
    let newHeight = metadata.height >= metadata.width ? 250 : undefined;

    return new Promise((resolve, reject) => {
      new Compressor(file, {
        width: newWidth,
        height: newHeight,
        success: (result) => {
          resolve(result);
        },
      });
    })    
  }

  protected async uploadFileToBucket(file:any, name:string) {
    let command = new PutObjectCommand({
      Bucket: ServerConfig.mediaBucket,
      Key: Server.user.getId() + '/' + name,
      Body: file
    });
  
    try {
      let response = await this.S3.send(command);
      console.log(response);
      return true;
    } catch (err) {
      console.error(err);
      return false;
    }
  }

  protected async deleteFileFromBucket(name:string) {
    let command = new DeleteObjectCommand({
      Bucket: ServerConfig.mediaBucket,
      Key: Server.user.getId() + '/' + name,
    });

    try {
      await this.S3.send(command);
      return true;
    } catch (err) {
      console.error(err);
      return false;
    }
  }

  protected async getImageMetadata(file:any, metadata:any) {
    let img = new Image();
    img.src = URL.createObjectURL(file);
    await img.decode();
    metadata.width = img.width;
    metadata.height = img.height;
  }

  protected async getVideoMetadata(file:any, metadata:any) {
    return new Promise((resolve, reject) => {
      let video = document.createElement('video');
      video.addEventListener('loadedmetadata', event => {
        metadata.width = video.videoWidth;
        metadata.height = video.videoHeight;
        metadata.duration = video.duration;
        resolve(metadata);
      });
      video.src = URL.createObjectURL(file);
    });    
  }

  protected async getAudioMetadata(file:any, metadata:any) {
    const url = URL.createObjectURL(file);
   
    return new Promise((resolve) => {
      const audio = document.createElement("audio");
      audio.muted = true;
      const source = document.createElement("source");
      source.src = url; //--> blob URL
      audio.preload= "metadata";
      audio.appendChild(source);
      audio.onloadedmetadata = function(){
        metadata.duarion = audio.duration;
        resolve(metadata);
      };
    });
  }

  // files
  public async uploadFile(file:any) {
    let i = file.name.lastIndexOf('.');
    if(i == -1)
      return {success: false, message: 'Invalid file name.'};

    let fileName = file.name.substring(0, i);
    let fileExt = file.name.substring(i+1);

    let params:any = {
      name: fileName,
      metadata: {
        ext: fileExt,
        type: file.type,
        size: file.size
      }
    }

    if(file.type.indexOf('image') == 0) 
      await this.getImageMetadata(file, params.metadata);
    else if(file.type.indexOf('video') == 0) 
      await this.getVideoMetadata(file, params.metadata);
    else if(file.type.indexOf('audio') == 0) 
      await this.getAudioMetadata(file, params.metadata);

    let response = await this.sendMediaCommand('create-file', params, 'id');
    if(!response.success)
      return response;

    let fileId = response.id;

    let success = await this.uploadFileToBucket(file, fileId + '.' + fileExt);

    if(success && file.type.indexOf('image') == 0) {
      if(params.metadata.width > 250 || params.metadata.height > 250) { 
        let thumb = await this.generateThumbImage(file, params.metadata);
        success = await this.uploadFileToBucket(thumb, fileId + '-thumb.' + fileExt);
      }
    }

    if(!success) {
      await this.sendMediaCommand('delete-file', {id: fileId});
      return {success: false, message: 'Failed to upload file.'};
    }

    return {success: true, id: fileId};
  }

  public async deleteFile(id:string) {
    let response = await this.sendMediaCommand('get-file', {id}, 'file');
    if(!response.success)
      return response;

    let file = response.file;

    await this.deleteFileFromBucket(file.id + '.' + file.metadata.ext);
    await this.deleteFileFromBucket(file.id + '-thumb.' + file.metadata.ext);
    await this.sendMediaCommand('delete-file', {id});

    return {success: true};
  }

  public async getFile(id:string) {
    return await this.sendMediaCommand('get-file', {id}, 'file');
  }

  public async updateFile(params: {id:string, name?:string, description?:string}) {
    return await this.sendMediaCommand('update-file', params);
  }

  public async getFiles(params: {sort?:string, before?:string, after?:string, limit?:number} = {}) {
    return await this.sendMediaCommand('get-files', params, 'files');
  }

  public getFileUrl(file:any, thumb:boolean=false) {
    let sep = '.';
    if(thumb && file.metadata.type.indexOf('image') == 0 && (file.metadata.width > 250 || file.metadata.height > 250))
      sep = '-thumb.';
    return 'https://s3.us-west-2.amazonaws.com/' + ServerConfig.mediaBucket + '/' + Server.user.getId() + '/' + file.id + sep + file.metadata.ext;
  }
}